import RESTAdapter from '@ember-data/adapter/rest';

import { registerBaseURL } from 'register-partners-js/constants/hosts';

export default class RegisterOrganizationAdapter extends RESTAdapter {
  host = registerBaseURL;
  namespace = 'v1';

  pathForType() {
    return 'stakeholders';
  }

  ajaxOptions() {
    let options = super.ajaxOptions(...arguments);
    options.credentials = 'include';

    return options;
  }
}
